import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/ErrorPage'
import Quax from '@/components/Quax/Index'
import QuaxScan from '@/components/Quax/Scan'
import QuaxActivity from '@/components/Quax/Activity'
import QiHan from '@/components/QiHan/Loading'
import QiHanIndex from '@/components/QiHan/Index'
import AiNiu from '@/components/AiNiu/Index'
import AiNiuScan from '@/components/AiNiu/Scan'
import FeiMi from '@/components/Feimi/Index'
import ZMNAnti from '@/components/ZhuoMuNiao/Anti'
import ZMNQuery from '@/components/ZhuoMuNiao/Query'
import LBTScan from '@/components/LiuBaoTang/Index'
import LBTQuery from '@/components/LiuBaoTang/Query'
import JZScan from '@/components/JiuZan/Index'
import JZQuery from '@/components/JiuZan/Query'
import MonTon from '@/components/MaiTeng/Index'
import MonTonStore from '@/components/MaiTeng/Store'
import SSScan from '@/components/ShengSheng/Index'
import SSResult from '@/components/ShengSheng/Result'
import SSJoin from '@/components/ShengSheng/Join'
import SSRule from '@/components/ShengSheng/Rule'
import BaXiaScan from '@/components/BaXia/Scan'
import BaXiaIndex from '@/components/BaXia/Index'
import BaXiaTrace from '@/components/BaXia/Trace'
import BaXiaJoin from '@/components/BaXia/Join'
import JST from '@/components/JinShaTan/Scan'
import JSTResult from '@/components/JinShaTan/Result'
import ZhuaQiuQuery from '@/components/ZhuaQiu/Query'
import ZhuaQiuResult from '@/components/ZhuaQiu/Result'
import ZhuaQiuTrace from '@/components/ZhuaQiu/Trace'
import ZhuaQiuJoin from '@/components/ZhuaQiu/Join'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/quax',
      name: 'QuaxAnti',
      component: Quax,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/ainiu',
      name: 'QuaxAnti',
      component: AiNiu,
      meta: {
        title: '积分查询'
      }
    },
    {
      path: '/ssheng',
      name: 'ShengSheng',
      component: SSScan,
      meta: {
        title: '盛生'
      }
    },
    {
      path: '/ssheng/result',
      name: 'ShengShengResult',
      component: SSResult,
      meta: {
        title: '盛生'
      }
    },
    {
      path: '/ssheng/join',
      name: 'ShengShengJoin',
      component: SSJoin,
      meta: {
        title: '盛生'
      }
    },
    {
      path: '/ssheng/rule',
      name: 'ShengShengRule',
      component: SSRule,
      meta: {
        title: '积分规则'
      }
    },
    {
      path: '/feimi',
      name: 'FeiMi',
      component: FeiMi,
      meta: {
        title: 'Feimibox费米盒子'
      }
    },
    {
      path: '/monton',
      name: 'MONTON',
      component: MonTon,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/monton/storePage',
      name: 'MONTON',
      component: MonTonStore,
      meta: {
        title: '一店一码首页'
      }
    },
    {
      path: '/zmn.query',
      name: 'zhuomuniao',
      component: ZMNQuery,
      meta: {
        title: '啄木鸟防伪查询'
      }
    },
    {
      path: '/lbt',
      name: 'liubaotang',
      component: LBTScan,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/lbt.query',
      name: 'liubaotang',
      component: LBTQuery,
      meta: {
        title: '防伪查询'
      }
    },
    {
      path: '/jz',
      name: 'liubaotang',
      component: JZScan,
      meta: {
        title: '世纪沉香坊'
      }
    },
    {
      path: '/jz.query',
      name: 'jz',
      component: JZQuery,
      meta: {
        title: '世纪沉香坊'
      }
    },
    {
      path: '/zmn',
      name: 'zhuomuniao',
      component: ZMNAnti,
      meta: {
        title: '啄木鸟防伪查询'
      }
    },
    {
      path: '/ainiu/scan',
      name: 'QuaxAnti',
      component: AiNiuScan,
      meta: {
        title: '积分查询'
      }
    },
    {
      path: '/quax/scan',
      name: 'QuaxAnti',
      component: QuaxScan,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/quax/activity',
      name: 'QuaxAnti',
      component: QuaxActivity,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/qh',
      name: 'QiHanIndex',
      component: QiHan,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/qh/index',
      name: 'QiHanIndex',
      component: QiHanIndex,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/bxia/scan',
      name: 'BaXiaScan',
      component: BaXiaScan,
      meta: {
        title: 'Vansia·王溪'
      }
    },
    {
      path: '/bxia/index',
      name: 'BaXiaIndex',
      component: BaXiaIndex,
      meta: {
        title: 'Vansia·王溪'
      }
    },
    {
      path: '/bxia/trace',
      name: 'BaXiaTrace',
      component: BaXiaTrace,
      meta: {
        title: 'Vansia·王溪'
      }
    },
    {
      path: '/bxia/join',
      name: 'BaXiaJoin',
      component: BaXiaJoin,
      meta: {
        title: 'Vansia·王溪'
      }
    },
    {
      path: '/jst',
      name: 'JST',
      component: JST,
      meta: {
        title: '青西金啤'
      }
    },
    {
      path: '/jst/result',
      name: 'JSTResult',
      component: JSTResult,
      meta: {
        title: '青西金啤'
      }
    },
    {
      path: '/zhuaqiu/query',
      name: 'ZhuaQiuQuery',
      component: ZhuaQiuQuery,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/zhuaqiu/result',
      name: 'ZhuaQiuResult',
      component: ZhuaQiuResult,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/zhuaqiu/trace',
      name: 'ZhuaQiuTrace',
      component: ZhuaQiuTrace,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/zhuaqiu/join',
      name: 'ZhuaQiuJoin',
      component: ZhuaQiuJoin,
      meta: {
        title: '抓球'
      }
    },
    {
      path: '/',
      name: 'ErrorPage',
      component: ErrorPage,
      meta: {
        title: '错误页'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js